import { createMainResourceREST } from '../resource';
import {
  CRDocumentBody,
  CRDocumentBodyAPI,
  CRDocumentKey,
  CRDocumentSummary,
  CRDocumentSummaryAPI,
  DocumentActions,
  DocumentState,
} from './types';

type AnyDocument = CRDocumentKey | CRDocumentBody | undefined;

function getEndpointDocument(key: AnyDocument): string {
  return key ? `/documents/${key.documentId}/` : '/documents/';
}

function sameDocument(a: AnyDocument, b: AnyDocument): boolean {
  return a?.documentId === b?.documentId;
}

function mergeDocument(last: CRDocumentBody, current: CRDocumentBody) {
  // always keep current, no merging from last necessary
  return current;
}

function parseDocumentBody(body: CRDocumentBodyAPI): CRDocumentBody {
  return body;
}

function parseDocumentSummary(
  summary: CRDocumentSummaryAPI,
): CRDocumentSummary {
  return summary;
}

function mergeSummaryBody(
  oldSummary?: CRDocumentSummary,
  curBody?: CRDocumentBody,
): CRDocumentSummary {
  return (curBody ?? oldSummary)! as any; // Summaries are not used for documents, so any it is
}

function selectDocumentQueryParams(body?: CRDocumentBody): any {
  const documentType = body?.documentType;
  return documentType ? { documentType } : undefined;
}

const documentsStateSelector = (state: any): DocumentState => state.document;

const currentDocumentSelector = (state: any): CRDocumentBody | undefined =>
  state.document.currentBody;

const { actions, reducer, watches, rawActions, useListener } =
  createMainResourceREST(
    'document',
    getEndpointDocument,
    documentsStateSelector,
    sameDocument,
    parseDocumentBody,
    parseDocumentSummary,
    mergeDocument,
    mergeSummaryBody,
    undefined,
    selectDocumentQueryParams,
  );

const documentsActions: DocumentActions = actions;
export * from './types';
export {
  documentsActions,
  useListener as useDocumentListener,
  reducer as documentReducer,
  watches as documentWatches,
  documentsStateSelector,
  currentDocumentSelector,
  rawActions as documentRawActions,
  getEndpointDocument,
};
